let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("idFp1")).then(() => parcelRequire('ifn8T'));